import { DialogHeader, DialogPrimitive, Dialog as DialogRoot } from "@gigpro/ui/Dialog";
import { useUsersLinkableAccountsList } from "@sidegigllc/api/client";
import { useMatchRoute } from "@tanstack/react-router";
import { AccountLinkingPrompt } from "domains/signUp/components/AccountLinkingPrompt";

/** Composed rather than `DialogTitle` so the eyebrow label sits inside the header, above the title. */
const DialogHeading = ({ children, className }: Readonly<{ className?: string; children: React.ReactNode }>) => (
  <DialogHeader hideCloseButton className="w-full pr-4">
    <p className="text-small font-semibold text-gray uppercase">Link your accounts</p>
    <DialogPrimitive.Title className={className}>{children}</DialogPrimitive.Title>
    <DialogPrimitive.Description className="hidden" />
  </DialogHeader>
);

export function AccountLinkingDialog({ open }: Readonly<{ open: boolean }>) {
  // The standalone page already renders the prompt — don't stack the modal on top of it.
  const matchRoute = useMatchRoute();
  const onLinkingPage = !!matchRoute({ to: "/account-linking" });
  const linkableAccounts = useUsersLinkableAccountsList("me", { query: { enabled: open } });

  return (
    <DialogRoot open={open && !onLinkingPage} className="sm:max-w-lg" contentClassName="items-center text-center">
      <AccountLinkingPrompt accounts={linkableAccounts.data} Heading={DialogHeading} />
    </DialogRoot>
  );
}
